import { HttpContextToken } from '@angular/common/http';

/**
 * HTTP context token to mark a request as a polling request.
 * When set to true, the polling interceptor will add the Session-Refresh: 0 header
 * to prevent session refresh during polling operations.
 */
export const IS_POLLING_REQUEST = new HttpContextToken<boolean>(() => false);
